<template>
  <div class="monitor-contanier">
    <div class="monitor-control-contanier">
      <Control :meeting="meeting" />
    </div>
    <List :meeting="meeting" />
    <!-- <div class="monitor-detail">
      <List :meeting="meeting" :partyList="partyList" />
    </div> -->
  </div>
</template>

<script>
// import Navigation from "@/components/navigation";
// import Bar from "./bar";
// import List from "./list";
import List from "./list";
import Control from "./control";

export default {
  components: {
    // List,
    List,
    Control
  },
  mounted() {
    // this.getConfMon();
    // 获取会议信息，成功后建立websocket连接
  },
  data() {
    return {};
  },
  computed: {
    meeting() {
      return this.$store.getters.meetingInfo;
    }
  },
  methods: {}
};
</script>

<style lang="less">
@border: 1px solid #e3e7ed;

.monitor-contanier {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-size: 16px;

  .monitor-control-contanier {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .monitor-detail {
    // width: 100%;
    // height: 100%;
    flex: 1;
    display: flex;
    overflow: hidden;
    position: relative;
    background-color: #ffffff;
    border: @border;
    border-radius: 0 4px 4px 4px;
    padding: 0 40px;
  }
}
</style>
